import config from './config';

const split = storeLocale => storeLocale.split(config.seperator);

export default split;
